import { render, staticRenderFns } from "./LocationCell.vue?vue&type=template&id=67b271e8&scoped=true"
import script from "./LocationCell.vue?vue&type=script&lang=js"
export * from "./LocationCell.vue?vue&type=script&lang=js"
import style0 from "./LocationCell.vue?vue&type=style&index=0&id=67b271e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b271e8",
  null
  
)

export default component.exports